<template>
    <!-- <div class="user-login">
    <el-input
      placeholder="用户ID"
      v-model="UserID"
      maxlength="11"
      class="phone-num"
    ></el-input>
    <el-button class="user-login-btn" @click="handleLogin">登陆</el-button>
  </div> -->
</template>

<script>
import { genTestUserSig2 } from "../../../public/debug/GenerateTestUserSig";
import { getUserSig } from '@/api/index'
export default {
    name: "Login",
    data () {
        return {
            UserID: "",
            verifyCode: "",
            disableFetchCodeBtn: false,
        };
    },
    methods: {
        isIe () {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
            var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
            var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
            if (isIE) {
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                if (fIEVersion == 7) {
                    return 7;
                } else if (fIEVersion == 8) {
                    return 8;
                } else if (fIEVersion == 9) {
                    return 9;
                } else if (fIEVersion == 10) {
                    return 10;
                } else {
                    return 6;//IE版本<=7
                }
            } else if (isEdge) {
                return 'edge';//edge
            } else if (isIE11) {
                return 11; //IE11  
            } else {
                return -1;//不是ie浏览器
            }
        },
        GetRequest (localUrl) {
            //url例⼦：XXX.aspx?ID=" + ID + "&Name=" + Name；
            var url = localUrl; //获取url中"?"符以及其后的字串
            var addressParameter = {};
            if (url.indexOf("?") != -1) {
                //url中存在问号，也就说有参数。
                var str;
                if (url.indexOf("=") != -1) {
                    str = url.substr(1, url.indexOf("=") - 1);
                } else {
                    str = url.substr(1);
                }
                //地址栏参数解密
                var addressUrl = decodeURIComponent(atob(str));
                var addressData = addressUrl.split("&");
                for (var i = 0; i < addressData.length; i++) {
                    addressParameter[addressData[i].split("=")[0]] = unescape(
                        addressData[i].split("=")[1]
                    );
                }
            }
            return addressParameter;
        },
        msgIe () {
            if (this.isIe() != -1) {
                let msg = '<p style="color:red">当前页面不支持ie浏览器，请更换（Chrome 浏览器、QQ 浏览器、Firefox 浏览器、Edge 浏览器、搜狗浏览器、360 安全浏览器）</p>'
                this.$alert(msg, '提示', {
                    confirmButtonText: '确定',
                    closeOnPressEscape: false,
                    showCancelButton: false,
                    dangerouslyUseHTMLString: true,
                    callback: action => {
                        // window.location.reload()
                    }
                });
            }
        },
        handleLogin: async function () {
            // axios
            const loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = this.GetRequest(window.location.search);
            let userSig;
            this.UserID = data.dw
            //   console.log(this.UserID,13123)
            let res = await getUserSig({
                userId: this.UserID
            })
            loading.close();
            userSig = res
            // let arr = genTestUserSig2(this.UserID)
            // // userSig = arr.userSig
            this.$store.commit("userLoginSuccess");
            this.$store.commit("setLoginUserInfo", {
                userId: this.UserID,
                userSig,
            });
    
        },
    },
    mounted () {
        console.log(this.$trtcCalling)
        this.handleLogin();
        this.msgIe()
    },
};
</script>

<style scoped>
.user-login {
    font-size: 16px;
    width: 400px;
    margin: 0 auto;
    padding-top: 50px;
}

.phone-num {
    margin-bottom: 5px;
}

.user-login-btn {
    margin-top: 10px;
    width: 100%;
}

@media screen and (max-width: 767px) {
    .user-login {
        font-size: 16px;
        width: 90%;
        min-width: 300px;
        margin: 0 auto;
        padding-top: 50px;
    }
}
</style>
